export const LIST_FAVORITES = "favorites";
// TODO(i18n): Use t tagged template: t`View favorites`
export const VIEW_FAVORITES = "View favorites";
// TODO(i18n): Use t tagged template: t`Saved!`
export const SAVED_FAVORITES = "Saved!";

export enum FreeDeliveryButtonTypes {
    TEXT = "text",
    ICON = "icon",
}

export enum DiscountDisplayMode {
    DISABLED = "disabled",
    AUTOMATIC = "automatic",
    SHOW_PERCENTAGE = "show-percentage",
    SHOW_ABSOLUTE = "show-absolute",
}

export enum RootProductSelectorInputType {
    DROPDOWN = "dropdown",
    RADIO = "radio",
}

export const MOBILE_WIDTH_THRESHOLD_ALTERNATIVE = 1200;
export const MOBILE_WIDTH_BODY_SCROLL = 768;
/**
 * Corresponds to the _Discontinued_ out of stock reason which can be configured
 * for product stock records. This is returned as the product availability code
 * in the product API.
 */
export const DISCONTINUED = "discontinued";
